import validateScore from './validateScore';

const validateCategoryOnChange = (
  immutableCategory,
  editableCategory,
  immutableSubcategories,
  editableSubcategories
) => {
  let isValid = true;
  let hasChanged = false;
  const performValidation = (immutable, editable) => {
    if (
      editable.value !== immutable.value ||
      editable.description !== immutable.description
    ) {
      hasChanged = true;
    }
    if (!validateScore(editable.value)) {
      isValid = false;
    }
  };

  performValidation(immutableCategory, editableCategory);

  editableSubcategories.forEach((sub) => {
    const originalSubcategory = immutableSubcategories.find(
      (original) => original.categoryId === sub.categoryId
    );
    performValidation(originalSubcategory, sub);
  });
  return isValid && hasChanged;
};

export default validateCategoryOnChange;
